import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import { ElMessageBox } from 'element-plus'
import { createChunkRecovery } from './chunkRecovery'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/views/layout/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '/account/profile', name: 'AdminProfile', component: () => import('@/views/account/AdminProfile.vue'), meta: { title: '个人资料' } },
      { path: '', name: 'Dashboard', component: () => import('@/views/dashboard/Dashboard.vue'), meta: { title: '仪表盘' } },
      { path: '/canteen/campus', name: 'CampusList', component: () => import('@/views/canteen/CampusList.vue'), meta: { title: '校区管理' } },
      { path: '/canteen/list', name: 'CanteenList', component: () => import('@/views/canteen/CanteenList.vue'), meta: { title: '食堂管理' } },
      { path: '/canteen/windows', name: 'WindowList', component: () => import('@/views/canteen/WindowList.vue'), meta: { title: '窗口管理' } },
      { path: '/canteen/categories', name: 'DishCategoryList', component: () => import('@/views/canteen/DishCategoryList.vue'), meta: { title: '分类管理' } },
      { path: '/canteen/dish-tags', name: 'DishTagList', component: () => import('@/views/canteen/DishTagList.vue'), meta: { title: '菜品标签管理' } },
      { path: '/canteen/dishes', name: 'DishList', component: () => import('@/views/canteen/DishList.vue'), meta: { title: '菜品管理' } },
      { path: '/user/list', name: 'UserList', component: () => import('@/views/user/UserList.vue'), meta: { title: '用户列表' } },
      { path: '/titles/management', name: 'TitleManagement', component: () => import('@/views/titles/TitleManagement.vue'), meta: { title: '头衔与活跃度' } },
      { path: '/merchant/list', name: 'MerchantList', component: () => import('@/views/merchant/MerchantList.vue'), meta: { title: '商家管理' } },
      { path: '/feedback/list', name: 'FeedbackList', component: () => import('@/views/feedback/FeedbackList.vue'), meta: { title: '反馈列表' } },
      { path: '/takeout/list', name: 'TakeoutList', component: () => import('@/views/takeout/TakeoutList.vue'), meta: { title: '外卖代取订单' } },
      { path: '/takeout/withdrawals', name: 'TakeoutWithdrawals', component: () => import('@/views/takeout/TakeoutWithdrawals.vue'), meta: { title: '代取提现审核' } },
      { path: '/takeout/settings', name: 'TakeoutSettings', component: () => import('@/views/takeout/TakeoutSettings.vue'), meta: { title: '外卖代取设置' } },
      { path: '/notification/list', name: 'NotificationList', component: () => import('@/views/notification/NotificationList.vue'), meta: { title: '通知列表' } },
      { path: '/notification/voting', name: 'VotingActivities', component: () => import('@/views/notification/VotingActivities.vue'), meta: { title: '投票榜单' } },
      { path: '/system/settings', name: 'SystemSettings', component: () => import('@/views/system/SystemSettings.vue'), meta: { title: '系统设置' } },
      { path: '/system/help-center', name: 'HelpCenterSettings', component: () => import('@/views/system/HelpCenterSettings.vue'), meta: { title: '帮助中心' } },
      { path: '/points/config', name: 'PointsConfig', component: () => import('@/views/points/PointsConfig.vue'), meta: { title: '积分配置' } },
      { path: '/points/rewards', name: 'RewardManage', component: () => import('@/views/points/RewardManage.vue'), meta: { title: '奖品管理' } },
      { path: '/points/exchanges', name: 'ExchangeAudit', component: () => import('@/views/points/ExchangeAudit.vue'), meta: { title: '兑换审核' } },
      { path: '/points/audit', name: 'DishAudit', component: () => import('@/views/points/DishAudit.vue'), meta: { title: '菜品审核' } },
      { path: '/health/foods', name: 'FoodManagement', component: () => import('@/views/health/FoodManagement.vue'), meta: { title: '食物管理' } },
      { path: '/health/exercises', name: 'ExerciseManagement', component: () => import('@/views/health/ExerciseManagement.vue'), meta: { title: '运动管理' } },
      { path: '/anti-fraud/management', name: 'AntiFraudManage', component: () => import('@/views/anti-fraud/AntiFraudManage.vue'), meta: { title: '云黑反诈' } },
      { path: '/food-menu/management', name: 'FoodMenuManagement', component: () => import('@/views/FoodMenuManagement.vue'), meta: { title: '今天吃什么' } },
      { path: '/textbook-transfer/management', name: 'TextbookTransferManage', component: () => import('@/views/textbook/TextbookTransferManage.vue'), meta: { title: '教材传递管理' } },
      { path: '/course-materials/management', name: 'CourseMaterialManage', component: () => import('@/views/course-materials/CourseMaterialManage.vue'), meta: { title: '资料共享管理' } },
      { path: '/permission-review', name: 'PermissionReview', component: () => import('@/views/PermissionReview.vue'), meta: { title: '权限审核' } }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.onError(createChunkRecovery({
  origin: window.location.origin,
  resolveHref: to => router.resolve(to || router.currentRoute.value.fullPath).href,
  navigate: href => window.location.assign(href),
  confirmReload: () => ElMessageBox.confirm(
    '页面资源加载失败，可能是系统刚刚更新或网络暂时异常。重新加载后将打开你选择的页面，当前未保存的内容会丢失。',
    '页面暂时无法打开',
    { confirmButtonText: '重新加载', cancelButtonText: '留在当前页', type: 'warning' }
  ).then(() => true).catch(() => false)
}))

const getStoredToken = () => {
  const token = store.getters['auth/token'] || localStorage.getItem('token')
  if (!token || token === 'undefined' || token === 'null') {
    return ''
  }
  return token
}

router.beforeEach((to, from, next) => {
  const token = getStoredToken()

  if (!token && store.getters['auth/isAuthenticated']) {
    store.commit('auth/CLEAR_AUTH')
  }

  if (to.meta.requiresAuth && !token) {
    next({
      path: '/login',
      query: to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {}
    })
    return
  }

  if (to.path === '/login' && token) {
    const redirectTarget = typeof to.query.redirect === 'string' ? to.query.redirect : '/'
    next(redirectTarget)
    return
  }

  next()
})

export default router
